export const valuePromotion = 250;
export const default_first_buy_coupon = `PRIMEIRA${valuePromotion}`;
